import classNames from 'classnames';
import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers, ReactNodeGenerator} from '../../../../../lib/helpers';
import {EditContentStore} from '../../../x7/content-parts/EditContentStore';
import {GroupingExerciseModel} from '../models';
import {GrexEditStore} from './GrexEditStore';

@observer
class GroupRender extends React.Component<{ store: GrexEditStore, index: number }> {
  render() {
    const {store, index} = this.props;
    const group = store.groups[index];
    const canRemoveGroup = store.groups.length > 2;

    const labelFgClassname = classNames('form-group',
      {'has-error': group.isLabelEmpty}
    );
    const contentsFgClassname = classNames('form-group',
      {'has-error': group.isGroupEmpty}
    );

    return (
      <div className="col">
        <div className={labelFgClassname}>
          <label>Group name</label>
          <input type="text" className="form-control"
                 value={group.label.value}
                 onChange={group.label.onChangeHandler}/>
          <div className="invalid-text">Group name must be specified</div>
        </div>
        <div className={contentsFgClassname}>
          <label>Group items</label>
          <textarea className="form-control"
                    value={group.lines.value}
                    onChange={group.lines.onChangeHandler}/>
          <div className="invalid-text">Items must be specified, one item per line.</div>
        </div>
        <div className="d-flex justify-content-end">
          <button className="btn btn-danger"
                  disabled={!canRemoveGroup}
                  onClick={() => store.removeGroup(index)}>
            Remove
          </button>
        </div>
      </div>
    );
  }
}

function* renderer(store: GrexEditStore): ReactNodeGenerator {
  const canAdd = store.groups.length < 5;

  yield (
    <div className="row justify-content-end" key="add-group">
      <div className="col-auto">
        <button type="button" className="btn btn-primary"
                onClick={store.addGroup}
                disabled={!canAdd}> Add group
        </button>
      </div>
    </div>);

  yield (
    <div className="row" key="groups">
      {
        store.groups.map((group, index) =>
          (<GroupRender store={store} key={index} index={index}/>))
      }
    </div>);
}

@observer
export class GrexEdit extends React.Component<{ store: EditContentStore }> {
  readonly store: GrexEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: EditContentStore }>) {
    super(props);

    this.store = new GrexEditStore();
    const value = props.store.content.Contents;
    const model = JSON.parse(value) as GroupingExerciseModel;
    this.store.sync(model);

    this.setup();
  }

  render() {
    return Array.from(renderer(this.store));
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
